// removed by extract-text-webpack-plugin
module.exports = {"container":"_15uwiET3aZ4OpVW7DGVRBx","messagesContainer":"_1kxZ2nWUHwPn6lQPwC8NzX"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15477a6a","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/messages/messages-list/messages-list.less
// module id = eDv9
// module chunks = 1